module.exports = __webpack_public_path__ + "static/media/game-bgm.2dda80a5.mp3";